import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeIND from '@angular/common/locales/en-IN';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CsIconModule } from '@cbuild/controls';
import {
  ByPassWorkerService,
  FIREBASE_CONFIG,
  TokenInterceptorService
} from '@cbuild/core';
import { CsCommonDataModule } from '@cbuild/cs-common-data-services';
import { CsDialogModule } from '@cbuild/dialog';
import { initializeApp } from 'firebase/app';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { NoProjectsComponent } from './no-projects/no-projects.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
registerLocaleData(localeIND, 'en-IN');
initializeApp(environment.firebaseConfig);
@NgModule({
  declarations: [AppComponent, UnderConstructionComponent, NoProjectsComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CsCommonDataModule.forRoot({
      loginRoute: '/accounts/login',
      noAccess: '/accounts/no-access'
    }),
    CoreModule,
    CsIconModule,
    CsDialogModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ByPassWorkerService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: FIREBASE_CONFIG,
      useValue: environment.firebaseConfig
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-IN'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
